export const reviews: Array<[string, string, string, string]> = [
  [
    'RP',
    'Ricardo P.',
    'Docente de Minería — México D.F., México',
    'Mis alumnos por fin entienden la diferencia entre exploración, explotación y procesamiento de minerales, y cómo se conectan con la realidad. Antes yo misma perdía tiempo buscando cómo explicar correctamente estos conceptos complejos. Ahora entro al aula con todo listo.',
  ],
  [
    'MG',
    'Mariana G.',
    'Profesor de Recursos Minerales — Santiago, Chile',
    'Nunca más llegué a una clase sin saber cómo explicar seguridad minera, métodos de explotación o gestión ambiental. El material hace el trabajo pesado por mí.',
  ],
  [
    'TL',
    'Tomás L.',
    'Docente de Ciencias — Bogotá, Colombia',
    'Las planificaciones me ahorran horas. Los proyectos sobre minería están organizados paso a paso. No improviso nunca más frente a mis alumnos.',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'MR',
    'Mariana R.',
    'Docente de Minería | Lima, Perú',
    'El material sobre depósitos minerales y geología minera le cambió la cara a mis alumnos. Por fin entienden dónde se encuentran los minerales y por qué. Es el recurso más claro que encontré para este tema. Lo uso desde la primera clase y los engancha de inmediato.',
  ],
  [
    'JC',
    'Jorge C.',
    'Profesor de Recursos Minerales | Montevideo, Uruguay',
    'El banco de 150 actividades vale por sí solo el precio del pack. Nunca más improviso una clase. Salgo de cada trimestre con la satisfacción de tener todo resuelto y mis alumnos motivados.',
  ],
  [
    'FG',
    'Fernando G.',
    'Docente de Ciencias | Caracas, Venezuela',
    'Los 100 casos prácticos transformaron cómo mis alumnos aprenden. Ahora analizan decisiones reales sobre minería, comprenden la seguridad y evalúan alternativas ambientales. Lo aplican directamente a situaciones reales. Eso no lo encontré en ningún otro material.',
  ],
  [
    'LM',
    'Laura M.',
    'Docente universitaria | Buenos Aires, Argentina',
    'El kit de evaluación me devolvió el tiempo de clase. Antes perdía mucho tiempo armando exámenes. Ahora tengo todo listo, coherente y vinculado con los contenidos. Mis alumnos saben exactamente qué van a ser evaluados.',
  ],
  [
    'PP',
    'Pablo P.',
    'Profesor de Minería | Quito, Ecuador',
    'El diccionario de conceptos fue una revelación. Mis alumnos finalmente entienden la terminología minera de forma clara. Desarrollan pensamiento crítico, cuestionan ideas previas, y comprenden la minería desde una perspectiva integral. Eso cambió completamente su relación con el tema.',
  ],
];
